import React, { Fragment, useState, useContext } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import {
  TableRow,
  TableCell,
  IconButton,
  Collapse,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Button,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { LangContext } from "../../context/lang";
import { getUserSearch } from "../../apis/user";

const useStyle = makeStyles((theme: Theme) => ({
  headerColumn: {
    borderBottom: "unset",
  },
  headerCellCollapse: { padding: `0px ${theme.spacing(2)}px` },
  textInput: { "& input": { padding: theme.spacing(1), fontSize: 14 } },
  selectInput: { padding: theme.spacing(1), fontSize: 14 },
  searchBtn: { textTransform: "unset" },
}));

interface UserList {
  setStateData: any;
  mockData: any;
  setPage: any;
}

interface StateList {
  name: string;
  organization: string;
  type: string;
  status: string;
}
const UserHeaderTable = (props: UserList) => {
  const classes = useStyle();
  const { setStateData, mockData, setPage } = props;
  const [filter, setfilter] = useState<Boolean>(false);
  const [search, setsearch] = useState<Boolean>(false);
  const { lang } = useContext(LangContext);
  const [state, setState] = useState<StateList>({
    name: "",
    organization: "",
    type: "officer_head",
    status: "enable",
  });

  const onFilter = async () => {
    setsearch(true);
    const searching = await getUserSearch(
      state.organization === "" ? "" : state.organization
    );
    if (searching.status.code === 200) {
      const filter = searching.data.filter((rs: any) => {
        let name = `${rs.first_name} ${rs.last_name}`;
        return (
          rs.role !== "root" &&
          rs.role !== "admin" &&
          rs.enabled === (state.status === "enable" ? true : false) &&
          rs.role === state.type &&
          (state.name === ""
            ? rs.first_name
            : name.toLocaleLowerCase().indexOf(state.name.toLowerCase()) !== -1)
        );
      });
      setStateData(filter);
      setPage(0);
    } else {
    }
  };

  const onClear = () => {
    setStateData(mockData);
    setState({
      name: "",
      organization: "",
      status: "enable",
      type: "officer_head",
    });
    setPage(0);
    setsearch(false);
  };
  return (
    <Fragment>
      <TableRow>
        <TableCell
          className={classes.headerColumn}
          align="left"
          style={{ width: 360 }}
        >
          {`${lang.data.name} - ${lang.data.lastname}`}
        </TableCell>
        <TableCell className={classes.headerColumn} align="center">
          {lang.data.organization}
        </TableCell>
        <TableCell align="center" className={classes.headerColumn}>
          {lang.data.type}
        </TableCell>
        <TableCell
          align="center"
          className={classes.headerColumn}
          style={{ width: 180 }}
        >
          {lang.data.status}
        </TableCell>
        <TableCell align="center" className={classes.headerColumn}>
          <IconButton
            size="small"
            onClick={() => {
              setfilter(!filter);
            }}
          >
            <Search />
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.headerCellCollapse} align="left">
          <Collapse in={Boolean(filter)} timeout="auto" unmountOnExit>
            <TextField
              variant="outlined"
              margin="dense"
              className={classes.textInput}
              value={state.name}
              name="name"
              onChange={(e: any) => {
                setState({
                  ...state,
                  name: e.target.value,
                });
              }}
              required
            />
          </Collapse>
        </TableCell>
        <TableCell className={classes.headerCellCollapse} align="center">
          <Collapse in={Boolean(filter)} timeout="auto" unmountOnExit>
            <TextField
              variant="outlined"
              margin="dense"
              className={classes.textInput}
              value={state.organization}
              name="organization"
              onChange={(e: any) => {
                setState({
                  ...state,
                  organization: e.target.value,
                });
              }}
              required
            />
          </Collapse>
        </TableCell>
        <TableCell className={classes.headerCellCollapse} align="center">
          <Collapse in={Boolean(filter)} timeout="auto" unmountOnExit>
            <FormControl variant="outlined" margin="dense">
              <Select
                classes={{ select: classes.selectInput }}
                value={state.type}
                onChange={(e: any) => {
                  setState({ ...state, type: e.target.value });
                }}
              >
                <MenuItem value={"officer_head"}>Officer head</MenuItem>
                <MenuItem value={"officer"}>Officer</MenuItem>
                <MenuItem value={"customer"}>Customer</MenuItem>
              </Select>
            </FormControl>
          </Collapse>
        </TableCell>

        <TableCell className={classes.headerCellCollapse} align="center">
          <Collapse in={Boolean(filter)} timeout="auto" unmountOnExit>
            <FormControl variant="outlined" margin="dense">
              <Select
                classes={{ select: classes.selectInput }}
                value={state.status}
                onChange={(e: any) => {
                  setState({ ...state, status: e.target.value });
                }}
              >
                <MenuItem value={"enable"}>Enable</MenuItem>
                <MenuItem value={"disable"}>Disable</MenuItem>
              </Select>
            </FormControl>
          </Collapse>
        </TableCell>
        <TableCell className={classes.headerCellCollapse} align="center">
          <Collapse in={Boolean(filter)} timeout="auto" unmountOnExit>
            <Button
              className={classes.searchBtn}
              color="primary"
              onClick={() => {
                if (search) {
                  onClear();
                } else {
                  onFilter();
                }
              }}
            >
              {search ? "ล้าง" : lang.data.search}
            </Button>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

export default UserHeaderTable;
